import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { navLinks, profile } from '../data/profile';
export function Footer() {
  return <footer className="w-full border-t border-line bg-white" data-id="element-283" data-mp="32oe11y52qfc8">
      <div className="mx-auto grid max-w-shell grid-cols-1 gap-10 px-6 py-14 sm:px-8 lg:grid-cols-[0.4fr_0.3fr_0.3fr]" data-id="element-284" data-mp="32m1bozwzl2p5">
        <div data-id="element-285" data-mp="3ufa4y995p9nd">
          <span className="font-serif text-lg font-semibold text-navy" data-id="element-286" data-mp="3ueigrjhw2e74">{profile.name}</span>
          <p className="mt-2 max-w-xs text-[13px] leading-relaxed text-charcoal-muted" data-id="element-287" data-mp="3990wknlzgb8">
            {profile.title}
          </p>
          <p className="mt-5 text-[12px] font-medium uppercase tracking-label text-charcoal-muted" data-id="element-288" data-mp="3ldkcr17ga6oj">
            {profile.location}
          </p>
        </div>

        <nav aria-label="Footer" data-id="element-289" data-mp="29zglw3w5synp">
          <h2 className="text-[11px] font-semibold uppercase tracking-label text-navy" data-id="element-290" data-mp="29y5kubu3m50a">Explore</h2>
          <ul className="mt-5 space-y-2.5" data-id="element-291" data-mp="2ezbf4e3eq0bx">
            {navLinks.map(link => <li key={link.to} data-id="element-292" data-mp="3l8qwa43iojrg">
                <Link to={link.to} className="text-[13px] text-charcoal-muted transition-colors duration-150 ease-premium hover:text-navy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2" data-id="element-293" data-mp="3la272nvdqrs2">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </nav>

        <div data-id="element-294" data-mp="817e07obdsul">
          <h2 className="text-[11px] font-semibold uppercase tracking-label text-navy" data-id="element-295" data-mp="80nrsermsiar">Contact</h2>
          <ul className="mt-5 space-y-3.5" data-id="element-296" data-mp="323239a09h0k">
            <li data-id="element-297" data-mp="ht3dnn61tr0x">
              <a href={profile.phoneHref} className="inline-flex items-center gap-2.5 text-[13px] text-charcoal-muted transition-colors duration-150 ease-premium hover:text-navy" data-id="element-298" data-mp="hriibvbwu420">
                <PhoneIcon className="h-3.5 w-3.5 text-metal" aria-hidden="true" data-id="element-299" data-mp="qrfboa98vr3e" />
                {profile.phone}
              </a>
            </li>
            <li data-id="element-300" data-mp="tvw8ij57pjh1">
              <a href={`mailto:${profile.email}`} className="inline-flex items-center gap-2.5 break-all text-[13px] text-charcoal-muted transition-colors duration-150 ease-premium hover:text-navy" data-id="element-301" data-mp="twfnbqzkfrqu">
                <MailIcon className="h-3.5 w-3.5 shrink-0 text-metal" aria-hidden="true" data-id="element-302" data-mp="18k0qfkwfxqyr" />
                {profile.email}
              </a>
            </li>
            <li data-id="element-303" data-mp="1ckt3yqccii0u">
              <a href={profile.linkedinUrl} target="_blank" rel="noreferrer noopener" className="inline-flex items-start gap-2.5 break-all text-[13px] text-charcoal-muted transition-colors duration-150 ease-premium hover:text-navy" data-id="element-304" data-mp="1clch7tr1wi8j">
                <LinkedinIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-metal" aria-hidden="true" data-id="element-305" data-mp="1rgisav50778q" />
                {profile.linkedinLabel}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-line" data-id="element-306" data-mp="2af3rznz78zik">
        <p className="mx-auto max-w-shell px-6 py-6 text-[12px] text-charcoal-muted sm:px-8" data-id="element-307" data-mp="2afx0ouhpxz3c">
          © {new Date().getFullYear()} {profile.name}. All rights reserved.
        </p>
      </div>
    </footer>;
}